// extracted by mini-css-extract-plugin
export default {"InfoBarHeaderSmall":"EventInfo_InfoBarHeaderSmall__Ut0Gk","eventLink":"EventInfo_eventLink__Adhpa"};